import { ColumnConfig, ColumnDataType } from '@aurora';

export const aircraftModelAircraftStatusColumnsConfig: ColumnConfig[] = [
    {
        type           : ColumnDataType.STRING,
        field          : 'aircraftStatus.name',
        searchableField: '$aircraftStatus.name$',
        sort           : 'aircraftStatus.name',
        translation    : 'Name',
        isUnaccent     : true,
    },
];
